export default __webpack_public_path__ + "static/media/fusible.87403eb2.jpg";